<script setup lang="ts">
import { RouterView, useRoute, useRouter } from 'vue-router'
import { ref, computed } from 'vue'
import BaseToast from '@/components/base-toast.vue'
import TwoColumnLayout from '@/layouts/two-column-layout.vue'
import PermissionErrorModal from '@/components/permission-error-modal.vue'
import { useCreateProjectModal } from '@/composables/useCreateProjectModal'
import { usePermissionError } from '@/composables/usePermissionError'

const route = useRoute()
const router = useRouter()
const { openCreateProjectModal } = useCreateProjectModal()
const { isPermissionErrorVisible, permissionErrorMessage, hidePermissionError } = usePermissionError()

// Check if current route should use the layout
const shouldUseLayout = computed(() => {
  return route.meta.useLayout === true
})

// Handle global create project event
const handleCreateProject = () => {
  // If not on dashboard, navigate there first
  if (route.path !== '/dashboard') {
    router.push('/dashboard')
  }

  // Open the modal using global state
  openCreateProjectModal()
}
</script>

<template>
  <template v-if="shouldUseLayout">
    <TwoColumnLayout :noSpacing="!!route.meta.noSpacing" @create-project="handleCreateProject">
      <RouterView />
    </TwoColumnLayout>
  </template>
  <template v-else>
    <RouterView />
  </template>
  <BaseToast />

  <!-- Global Permission Error Modal -->
  <PermissionErrorModal
    :is-visible="isPermissionErrorVisible"
    :message="permissionErrorMessage"
    @close="hidePermissionError"
    @dashboard-redirect="hidePermissionError"
  />
</template>

<style>
#app {
  width: 100%;
  height: 100vh;
  font-family:
    'SF Pro Display',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}
</style>
